import guest from "@/middleware/guest";

export default [
  {
      path: "",
      component: () => import("@/modules/layout/LandingLayout"),
      children: [
          {
              path: "/pesquisa/:mailing",
              name: "pesquisa",
              meta: { middleware: [guest] },
              component: () => import("./Pesquisa"),
          },
      ]
  },
];
